export default __webpack_public_path__ + "static/Laptop-05798e0f50dec4be8e99ca95de137c1d.webp";